import mitt from "mitt";
const emitter = mitt();
// 定义事件类型
const Events = {
  EventMin: "EventMin",
  Update_Account: "Update_Account",
  Refresh_Account_Info: "Refresh_Account_Info",
};

export { emitter, Events };
